import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';

const skillCategories = [
  {
    category: 'Languages',
    skills: [
      { name: 'JavaScript (ES6+) / TypeScript', level: 90 },
      { name: 'Java', level: 85 },
      { name: 'C / C++', level: 85 },
      { name: 'SQL', level: 82 },
      { name: 'HTML5 & CSS3', level: 95 },
    ],
  },
  {
    category: 'Frontend',
    skills: [
      { name: 'React.js & Next.js', level: 88 },
      { name: 'Redux Toolkit & Context API', level: 85 },
      { name: 'Tailwind CSS & Bootstrap', level: 90 },
      { name: 'jQuery & Responsive Design', level: 82 },
    ],
  },
  {
    category: 'Backend',
    skills: [
      { name: 'Node.js & Express.js', level: 88 },
      { name: 'Java Spring Boot', level: 82 },
      { name: 'RESTful API Engineering', level: 90 },
      { name: 'Microservices Architecture', level: 80 },
    ],
  },
  {
    category: 'Databases & Tools',
    skills: [
      { name: 'MongoDB (Mongoose) & MySQL', level: 85 },
      { name: 'Redis (In-Memory Caching)', level: 80 },
      { name: 'Git / GitHub & Postman', level: 90 },
      { name: 'Docker, CI/CD & Linux', level: 80 },
      { name: 'System Design & DSA', level: 85 },
    ],
  },
];

const Skills = () => {
  return (
    <Container className="skill-container" id="skills">
      <div>
        <h2 className="header-clr">Skills</h2>
        <div className="divider"></div>
        <br />
        <p>
          Categorized overview of technical capabilities covering programming languages, frontend engineering, backend services, and database & dev tools[cite: 1, 3].
        </p>

        <Row className="g-4 mt-1">
          {skillCategories.map((group, index) => (
            <Col lg={6} md={12} key={index}>
              <div className="skill-category-card">
                <h4 className="skill-category-title">{group.category}</h4>
                <div className="skill-list">
                  {group.skills.map((skill, sIdx) => (
                    <div className="skill-item" key={sIdx}>
                      <div className="skill-info">
                        <span className="skill-name">{skill.name}</span>
                        <span className="skill-percent">{skill.level}%</span>
                      </div>
                      <ProgressBar variant="info" now={skill.level} />
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </Container>
  );
};

export default Skills;